export default "__VITE_ASSET__pY8kvRcN__"